import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {ThemePalette} from "@angular/material/core";
import {
  Config,
  getConfig, getSelectedBusinessUnit,
  getThemeState,
  initialConfigState,
  initialThemeState,
  Theme,
  updateUserId
} from "../../../redux";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {Store} from "@ngrx/store";
import {UsersService} from "../../services/users/users.service";
import {Subscription} from "rxjs";
import {IBusinessUnit} from "../../../business-units/models";
import {ToastrService} from "ngx-toastr";
import {INavItem} from "../../../../models";
import {toggleNavigating} from "../../../redux/stores/config/config.actions";
import {AppFade} from "../../../../animations/animations";
import {IAppUserRequest} from "../../models/i-users";

@Component({
  selector: 'app-user-navigation',
  templateUrl: './user-navigation.component.html',
  styleUrls: ['./user-navigation.component.scss'],
  animations: [AppFade()],
})
export class UserNavigationComponent implements OnInit, OnDestroy, AfterViewInit {
  loading = false;
  animationState = false;

  links: INavItem[] = [
    {title: 'Information', link: '/information', enabled: true, hidden: false, icon: '', toolTip: ''},
    {title: 'Business Units', link: '/business-units', enabled: true, hidden: false, icon: '', toolTip: ''},
    {title: 'Activity', link: '/activity', enabled: true, hidden: false, icon: '', toolTip: ''},
    {title: 'Email Notifications', link: '/email-notifications', enabled: true, hidden: false, icon: '', toolTip: ''}
  ];
  activeLink: INavItem = {} as unknown as INavItem;
  background: ThemePalette = undefined;

  userId: string | null = '';
  selectedUser: IAppUserRequest = {} as unknown as IAppUserRequest;

  config$: Subscription = new Subscription();
  theme$: Subscription = new Subscription();
  route$: Subscription = new Subscription();

  selectedBusinessUnit$: Subscription = new Subscription();
  selectedBusinessUnit: IBusinessUnit = {} as unknown as IBusinessUnit;
  selectedUserId$:Subscription = new Subscription();
  selectedUserId = '';
  config: Config = initialConfigState;
  theme: Theme = initialThemeState;

  constructor(
    private usersService: UsersService,
    private router: Router,
    private route: ActivatedRoute,
    private store: Store,
    private toastrService:ToastrService
  ) {
    // this.route$ = this.router.events.subscribe((e: any) => {
    //   if (e instanceof NavigationEnd) {
    //     this.loading = true;
    //     this.store.dispatch(toggleNavigating({navigating: true}));
    //     setTimeout(() => {
    //       this.store.dispatch(toggleNavigating({navigating: false}));
    //       this.loading = false
    //     }, 1000);
    //   }
    // });

    this.config$ = this.store.select(getConfig).subscribe((config: Config) => {
      this.config = config;
    });

    this.theme$ = this.store.select(getThemeState).subscribe((theme: any) => {
      this.theme = theme;
    });

    this.selectedBusinessUnit$ = this.store.select(getSelectedBusinessUnit).subscribe((bu: IBusinessUnit) => {
      if (!!bu && !!bu.businessUnitId && this.selectedBusinessUnit.businessUnitId != bu.businessUnitId) {
        this.selectedBusinessUnit = bu;
        this.subscribeToDatasource();
      }
    });
  }

  ngOnInit(): void {
    this.animationState = true;
  }

  subscribeToDatasource(){
    this.getUserIdFromRoute();
    this.getUser();
    this.setActiveLink();
  }

  ngOnDestroy() {
    this.config$.unsubscribe();
    this.theme$.unsubscribe();
    this.selectedBusinessUnit$.unsubscribe();
    this.route$.unsubscribe();
  }

  ngAfterViewInit() {

  }

  getUser() {
    this.loading = true;
    setTimeout(() => {
      if (!!this.userId) {
        this.usersService.getUserById(this.userId).subscribe({
          next: (user: any) => {
            this.selectedUser = user;
            this.toastrService.success("User Loaded!", $localize`:@@companyName:Rondeivu`);
            this.loading = false;
          }, error: (error: any) => {
            this.loading = false;
            this.toastrService.error("Unable to get user!", $localize`:@@companyName:Rondeivu`);
          }
        });
      }
      this.loading = false;
    }, 1000);
  }

  getUserIdFromRoute() {
    this.userId = this.route.snapshot.paramMap.get('id');
    if (!!this.userId) {
      this.store.dispatch(updateUserId({userId: this.userId}));
    }
  }

  setActiveLink() {
    const fragments = this.router.url.split('/');
    let link = '/' + fragments[fragments.length - 1];
    this.links.forEach(l => {
      if (l.link == link) {
        this.activeLink = l;
      }
    });
  }

  navigate(obj: { title: string; link: string; enabled: boolean }) {
    this.store.dispatch(toggleNavigating({navigating: true}));
    this.animationState = false;
    setTimeout(() => {
      this.router.navigate(['/' + this.config.selected_business_unit.slug + '/users/' + this.userId + obj.link]).then(() => {
        this.animationState = true;
        this.store.dispatch(toggleNavigating({navigating: false}));
      });
    }, 300);
  }

  goBack() {
    this.store.dispatch(toggleNavigating({navigating: true}));
    this.animationState = false;
    setTimeout(() => {
      this.router.navigate(['/' + this.config.selected_business_unit.slug + '/users']).then(() => {
        this.animationState = true;
        this.store.dispatch(toggleNavigating({navigating: false}));
      });
    }, 300);
  }

}
